import Vue from 'vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import SomeCodeSalts from './additionalData/codeSalts.js';
import op from './additionalData/operations.js';
import extra from './someData/operations.js';
import Extra from './someData/coperations.js';
import md5 from 'js-md5';
Vue.mixin({
  methods: {
    ...mapActions([
      "updateIsLogin",
      "updateIsInAlert",
      "updateIsQrCode",
      "updateIsCompleteRegistration",
      "updateAlertMessage",
      "updateDeviceId",
      "updateUserToken",
      "updateImageServer",
      "updateTags",
      "updateCategories",
      "updateLocations",
      "updateOffers",
      "updateLoader",
      "updateUserId",
      'updateEmailUser',
      "updateNameUser",
      "updateUserType",
      "updateDashboardActive",
      "updateCapacityValidator",
      'updateUserIdEncrypt',
      'updateCompany',
      'updateScanDevicesIps',
      'updateScanDevicesSockets',
      'updateUserRoles',
      "updateSublocationId",
      "updateBookingDate",
      "updateCompanyLoaded",
      "updateSessionCompanyId",
      "updateIsVantiQrCode",
      "updatePaymentMethod",
      "updateSelectedTask",
      "updateUserLocations",
      "updateUserInfoType",
      "updateUserIsApprover",
      "updateUserInfoType",
    ]),
    ...mapGetters([
      "getIsLogin",
      "getIsInAlert",
      "getIsQrCode",
      "getIsCompleteRegistration",
      "getAlertMessage",
      "getDeviceId",
      "getUserToken",
      "getImageServer",
      "getTags",
      "getCategories",
      "getLocations",
      "getOffers",
      "getLoader",
      "getUserId",
      "getUserType",
      'getEmailUser',
      'getNameUser',
      "getDashboardActive",
      "getCapacityValidator",
      'getUserIdEncrypt',
      'getCompany',
      'getScanDevicesIps',
      'getScanDevicesSockets',
      'getUserRoles',
      "getSublocationId",
      "getBookingDate",
      "getCompanyLoaded",
      "getSessionCompanyId",
      "getIsVantiQrCode",
      "getPaymentMethod",
      "getSelectedTask",
      "getUserLocations",
      "getUserInfoType",
      "getUserIsApprover",
      "getUserInfoType",
    ]),
    ...mapMutations([
      "setInvitationTimer",
      "clearInvitationCheckerTimer",
    ]),
    checkToken(token){
      if (this.getUserToken() !== token) {
        this.updateUserToken(token);
        // this.updateUserSignIn(true);
      }
    },
    encrypt(data) {
      var CryptoJS = require("crypto-js");
      var payload = "G7qeaR2Yb4DAgk92ZQHdjQ==|gfYvWJ0vVdX142/xpsGPW8Fsgc/dGeQPFtaazcUMjQo=|VF/bl6Ae5CVTtQTPCrmAgQ==".split("|");
      var iv = payload[0], hmac = payload[1], cipherText = payload[2];
      var passphraseDgst = CryptoJS.SHA256("ImAwesomeAndHappy").toString();
      var key = passphraseDgst;
      var encrypted = CryptoJS.AES.encrypt(
        JSON.stringify(data),
        CryptoJS.enc.Hex.parse(passphraseDgst),
        {iv:CryptoJS.enc.Base64.parse(iv)}
      );
      return encrypted
    },
    findCategories(){
      // if(this.getCategories().length <= 0){
        try {
          this.$http.get('app/categories',{
          params:{
            company:{id:this.getCompany().id
          },
            headers:
            {"X-Device-ID" : this.getDeviceId(),
             "Authorization" : 'Bearer ' + this.getUserToken()}}}
          )
          .then(function(response){
            this.updateCategories(response.body.data)
          }, function(response){
            if(typeof response.body.errors[0].details != "object"){
              alert(response.body.errors[0].details);
            }else{
              let message = []
              for(var key in response.body.errors[0].details){
                message.push(response.body.errors[0].details[key])
              }
              alert(message);
            }
          })
        } catch (e) {
          alert(e.message)
        }
      // }
    },
    findTags(){
      // if(this.getTags().length <= 0){
        try {
          this.$http.get('app/tags',)
          .then(function(response){
            this.updateTags(response.body.data)
          }, function(response){
            if(typeof response.body.errors[0].details != "object"){
              alert(response.body.errors[0].details);
            }else{
              let message = []
              for(var key in response.body.errors[0].details){
                message.push(response.body.errors[0].details[key])
              }
              alert(message);
            }
          })
        } catch (e) {
          alert(e.message)
        }
      // }
    },
    findLocations(){
      // if(this.getLocations().length <= 0){
        try {
          this.$http.get('app/locations',{
            params:{
              company:{
                id:this.getCompany().id
              },
              headers:{
                "X-Device-ID" : this.getDeviceId(),
                "Authorization" : 'Bearer ' + this.getUserToken(),
              }
            },
            headers: {
              "skip": "skip",
            }
          })
          .then(function(response){
            this.updateLocations(response.body.data)
          }, function(response){
            if(typeof response.body.errors[0].details != "object"){
              alert(response.body.errors[0].details);
            }else{
              let message = []
              for(var key in response.body.errors[0].details){
                message.push(response.body.errors[0].details[key])
              }
              alert(message);
            }
          })
        } catch (e) {
          alert(e.message)
        }
      // }
    },
    findOffers(){
      // if(this.getOffers().length <= 0){
        try {
          this.$http.get('offers')
          .then(function(response){
            this.updateOffers(response.body.data)
          }, function(response){
            if(typeof response.body.errors[0].details != "object"){
              alert(response.body.errors[0].details);
            }else{
              let message = []
              for(var key in response.body.errors[0].details){
                message.push(response.body.errors[0].details[key])
              }
              alert(message);
            }
          })
        } catch (e) {
          alert(e.message)
        }
      // }
    },

    makeCacheCopy(){
      return new Promise(async function(resolve, reject) {
        const exec  = window.require('child_process').exec;
        let filePath= localStorage.getItem("fingerprint_API_env")
        if(!filePath){
          filePath=window.process.env.APPDATA+"/Service_Fingerprint/"
        }
        let originalFile=window.process.env.APPDATA+"/roar-desktop-app-nativefier-1080f2"
        let backupFile=filePath+'Counter_Backup'
        await exec('xcopy "'+originalFile+'/Cache" "'+backupFile+'/Cache" /E /I /Y', async function(error, stdout, stderr){
          if(error||stderr){
            reject()
          }
          await exec('xcopy "'+originalFile+'/IndexedDB" "'+backupFile+'/IndexedDB" /E /I /Y', async function(error2, stdout2, stderr2){
            if(error2||stderr2){
              reject();
            }
            resolve()
          });
        })

      })

    },
    downloadFingerprint(fingerprint,rut){
      return new Promise(function(resolve, reject) {
        let fs=window.require("fs");
        let http = require('http');
        if (!fs) {
          alert('The File APIs are not fully supported in this browser.');
        }
        let filePath= localStorage.getItem("fingerprint_API_env")
        if(!filePath){
          filePath=window.process.env.APPDATA+"/Service_Fingerprint/"
        }
        let myDest=filePath+"Fingerprints/A_"+md5(rut)+".fpt"
        let myFingerFile = fs.createWriteStream(myDest);
        myFingerFile.on('error', function (err) {
          console.error(err);
        });
        let myCompareFile= fs.createWriteStream(filePath+"Name_to_match.txt")
        myCompareFile.on('error', function (err) {
          console.error(err);
        });
        let request = http.get(fingerprint, function(response) {
          response.pipe(myFingerFile);
          myFingerFile.on('finish', function() {
            myFingerFile.end();
            myCompareFile.write("A_"+md5(rut))
            myCompareFile.end()
            resolve()
          });
        }).on('error', function(err) { // Handle errors
            console.error(err)
            myFingerFile.end();
            fs.unlink(myDest); // Delete the file async. (But we don't check the result)
            reject()
        });
      })
    },
    async review_counter_user(data){
      let a=await op.getData(SomeCodeSalts.enc_data)
      let ans= await extra.removeData(a,10)
      let ans2= await  extra.removeData(a,1)
      let an51= await Extra.removeData(a,10)
      let an52= await  Extra.removeData(a,1)
      let finalValidation=await Extra.validate(this.$localforage.ttjdtbb486b51c9842efdaecd194,data,ans,ans2,an51,an52)
      return finalValidation;
    },
    decrypt_info(data){
      var CryptoJS = require("crypto-js");
      var iv = CryptoJS.enc.Base64.parse("kT+uMuPwUk2LH4cFbK0GiA==")
      var key = CryptoJS.enc.Hex.parse("6476b3f5ec6dcaddb637e9c9654aa687")
      let decrypted_value = CryptoJS.AES.decrypt(data,  key,  {mode: CryptoJS.mode.CBC,  iv : iv}).toString(CryptoJS.enc.Utf8)
      return JSON.parse(decrypted_value);
    },
    convertDaytimeFormatToHour(hour){
      var arr=hour.split(":")
      let hours=Number(arr[0])
      let secondArr=arr[1].split(" ")
      var minutes=secondArr[0]
      var amOrPm=secondArr[1]
      var finalHour=[hours,minutes]

      if(amOrPm=="pm" && hours!=12){
        finalHour[0]= (Number(hours)+12)%24
      }else if(hours==12 && amOrPm=="am" ){
        finalHour[0]=0
      }
      return finalHour[0].toString().padStart(2,"0")+":"+finalHour[1].toString().padStart(2,"0");
    },
    convertDurationFormat(time){
      if (time!==null && time!==undefined){
        let arr=time.split(" h ")
        return arr[0]+":"+arr[1].toString().padStart(2,"0");
      }
    },
    addHours(hour1,hour2){
      if (hour1!==null && hour1!==undefined && hour2!==null && hour2!==undefined ){
        let arr1=hour1.split(":");
        let arr2=hour2.split(":");
        return this.formatDay(Number(arr1[0])+Number(arr2[0]),Number(arr1[1])+Number(arr2[1]))
      }
    },
    firstIsGreaterThanSecond(hour1,hour2){
      if (hour1!==null && hour1!==undefined && hour2!==null && hour2!==undefined ){
        let arr1=hour1.split(":");
        let arr2=hour2.split(":");
        let ans=false;
        if( Number(arr1[0])>Number(arr2[0]) || (Number(arr1[0]) == Number(arr2[0]) && Number(arr1[1]) > Number(arr2[1]))){
          ans=true
        }
        return ans
      }
    },
    formatDay(hour,minutes){
      if(minutes>=60){
        hour+=(minutes/60)
        minutes=minutes%60
      }
      if(hour>=24){
        hour=hour%24
      }
      return hour.toString().padStart(2,"0")+":"+minutes.toString().padStart(2,"0");
    },
    shortDate(date){
      let new_date =  date.substring(0,date.indexOf('T'))
      return new_date
    },
    buildDeviceId(){
      let uuid
      if(localStorage.device_id !== undefined &&
        localStorage.device_id != null &&
        localStorage.device_id !== '' &&
        localStorage.device_id !== 'null'){
        uuid = localStorage.device_id
      } else {
        uuid = this.$uuid.v1()
        localStorage.device_id = uuid
      }
      this.updateDeviceId(uuid);
      return uuid
    },
    findBookingsLocation(){
      let data = { company: {id: this.getCompany().id}}
      let weekday = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][new Date().getDay()]
      let current_datetime = new Date().toISOString().replace(/[ZT]/g,' ');
      this.$http.post('app/locations/locations_datetime',{data:this.encrypt(data).toString()},{
        params:{
          day_name: weekday,
          page: 0,
          current_datetime: current_datetime
        }
      })
      .then(function(response){
        let find_locations_datetime = response.body.data
        let location_get_population_quantity = response.body.meta.location_get_population_quantity

        let new_locations = []

        for (var i = 0; i < find_locations_datetime.length; i++) {
          let new_obj ={
            name: location_get_population_quantity[i].location_name,
            current_population: location_get_population_quantity[i].current_population,
            max_capacity: 0,
            location_id: location_get_population_quantity[i].location_id,
            location_type: location_get_population_quantity[i].location_type
          }
          new_locations.push(new_obj)
        }

        let booking_locations = new_locations.find( ({ location_type }) => location_type === 'Reserva General');
        this.getCompany().has_booking_locations = !!booking_locations;
      })
    },
    validateUserCredentials(email, password, company_id){
      let data = {
        attributes: {
          email: email,
          password: password,
          company: company_id
        }
      }
      try {
        this.$http.post("users/sign_in", {
            data: this.encrypt(data).toString()
          },{
          headers:{
            "X-Device-ID" : this.getDeviceId()
          }
        }).then(function(response) {
            if (response.body.meta !== undefined && response.body.meta != null) {
              if (response.body.meta.authentication_token !== undefined && response.body.meta.authentication_token != null) {
                this.checkToken(response.body.meta.authentication_token);
              }
            }
            if (response.body && response.status == 201) {
              this.updateUserId(response.body.data.id)
              this.updateUserType("RegisteredUser");
              this.updateIsLogin(true);
              this.$router.push({name: 'complete_registration'});
            }else{
              alert("falla");
              this.updateIsLogin(false);
            }
          },
          function(response) {
            if (response.body.meta != undefined && response.body.meta != null) {
              if (response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null) {
                this.checkToken(response.body.meta.authentication_token);
              }
            }
            this.updateAlertMessage("Los datos de usuario recibidos son incorrectos, por favor comunicate con el administrador");
            this.updateIsInAlert(true);
          }
        );
      } catch (e) {
          this.updateAlertMessage(e.message);
          this.updateIsInAlert(true);
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/vue/mixins.js